module.exports = __webpack_public_path__ + "static/img/table-code.90895108.png";